import {
  PageConfig,
  StoryboardComponentDependencies,
} from '../../../../common/components/dashboards/types';
import { TimeSliderTypes } from '../../../../common/components/timeslider/types';
import { Languages } from '../../../../constants';
import {
  getNikkiTotalNumberFactbox,
  getNikkiTotalNumberVsOperationalStaffFactbox,
  jphilContractStaffBarChartConfig,
  yocAgencyStaffBarChartConfig,
} from './nikki-global-hr-as-chart-helpers';

export const getNikkiGlobalHRDbPageConfigs = (
  dashboardId: string
): PageConfig[] => {
  const pageComponents = ({
    storyboardDateUtils,
  }: StoryboardComponentDependencies) => {
    return [
      yocAgencyStaffBarChartConfig(storyboardDateUtils),
      getNikkiTotalNumberVsOperationalStaffFactbox(storyboardDateUtils),
      jphilContractStaffBarChartConfig(storyboardDateUtils),
      getNikkiTotalNumberFactbox(storyboardDateUtils),
    ];
  };
  const pageConfig: PageConfig = {
    pageId: '1',
    dashboardId,
    pageNumber: 1,
    enabled: true,
    title: {
      [Languages.EN]: 'Agency Staff MP Capacity',
      [Languages.JA]: 'Agency Staff MP Capacity',
    },
    pageOptions: {
      displayOptions: {
        enabled: true,
      },
      timeSlider: {
        enabled: true,
        type: TimeSliderTypes.POINT,
      },
      filterTray: {
        enabled: false,
      },
      dataView: {
        enabled: false,
      },
      segmentationLevel1: {
        enabled: false,
      },
      segmentationLevel2: {
        enabled: false,
      },
      benchmark: {
        enabled: false,
      },
      forecast: {
        enabled: false,
      },
    },
    gridCols: 4,
    gridRows: 16,
    components: pageComponents,
  };
  return [pageConfig];
};
